export const DONATE_URL = "https://buy.stripe.com/bJe14n6tT3ZM4H73Ze7g400";
export const DONATE_LABEL = "Buy me a coffee";
